import { Props } from '~/containers/Finalization';
import { isAutoOnlyMediaAlphaActivated } from '~/util/optimizelyHelpers';

function meetsDataDependencies(props: Props) {
  const {
    application: { autoApplicants, vehicles },
  } = props;

  return autoApplicants.length > 0 && vehicles.length > 0;
}

const step = {
  route: '/homeowners-insurance/quotes/finalization',
  isAccessible: ({ application }: Props) =>
    application.bundled || (application.isAutoOnly && !isAutoOnlyMediaAlphaActivated()),
  breadcrumbStep: 'property',
  meetsDataDependencies,
};

export default step;
